export default __webpack_public_path__ + "65a9994740b80337ea67b42603d20642.png";